const { Divider, Space } = require("antd")

const CardHeader = ({ heading, hideHeaderBlueLine = false, style }) => {
    return <div className="d-flex" style={{ alignItems: "center", gap: "0.6rem", flex: 1, ...style }}>
        {!hideHeaderBlueLine && <div type='vertical' style={{ width: "0.3rem", height: "2rem", backgroundColor: "var(--primary)", borderRadius: "4px" }} />}
        <span className="textLG w-700 black">{heading}</span>
    </div>
}

export { CardHeader }